import React from 'react';
import { GoalComponentProps as Props } from '../../../../components/Goal/Goal.meta';
import { DeleteEstatePlanningGoal } from '../DeleteEstatePlanningGoal/DeleteEstatePlanningGoal';
import { AddGoalModal } from '../../../../components/AddGoalModal/AddGoalModal';

export const NonEditableGoal = ({ clientId, name, id, goalData, onClose }: Props) => {
  if (id) {
    return (
      <DeleteEstatePlanningGoal clientId={clientId} goalId={id} data={goalData} onClose={onClose} />
    );
  }

  return (
    <AddGoalModal
      clientId={clientId}
      name={name}
      message="After you click on Add Goal below, you will be able to view the Estate Planning Module within the Goal Results section."
      url="/Consumer/GoalUpdate/SaveEstatePlanningGoal"
      onClose={onClose}
    />
  );
};
